import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import logoPrimary from "../../img/logo/nualang-logo-primary.svg";
import defaultErrorImage from "../../img/default-error-image.svg";
import defaultErrorImage2 from "../../img/default-error-image-2.svg";
import config from "../../config";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { searchStringToObj } from "../../utils";

const Logo = styled("img")(() => ({
  height: 50,
}));

const DefaultErrorImage = styled("img")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "block",
    maxHeight: "200px",
  },
  display: "block",
  maxHeight: "300px",
  margin: "auto",
}));

function DefaultError({ error }) {
  const params = searchStringToObj(window.location.search);
  const validErrorMessages = ["no_classroom_to_join"];
  const validErrorRedirects = [
    "https://stagelearningsite.waysidepublishing.com/",
    "https://learningsite.waysidepublishing.com/",
  ];
  const isChunkLoadError = error?.message?.includes("ChunkLoadError");

  let errorMessage = null;

  if (validErrorMessages.includes(params.errorMessage)) {
    errorMessage = params.errorMessage;
  } else if (isChunkLoadError) {
    errorMessage =
      "The app has been updated, please reload the app to see the latest changes.";
  }

  const errorRedirect = validErrorRedirects.includes(params.errorRedirect)
    ? params.errorRedirect
    : null;

  const { t } = useTranslation();

  const redirectUrl = errorRedirect ?? "/";

  return (
    <Dialog fullScreen open={true}>
      <Grid
        container
        direction="column"
        spacing={3}
        sx={{
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          p: 2
        }}>
        <Grid>
          <Link to={redirectUrl} reloadDocument>
            <Logo src={logoPrimary} />
          </Link>
        </Grid>
        <Grid>
          <Link to={redirectUrl} reloadDocument>
            <DefaultErrorImage
              src={errorMessage ? defaultErrorImage2 : defaultErrorImage}
              alt="Error"
            />
          </Link>
        </Grid>
        <Grid>
          <Box sx={{
            textAlign: "center"
          }}>
            {errorMessage ? (
              t(errorMessage)
            ) : (
              <Typography>
                Something went wrong, please{" "}
                <a href={`${config.SITE_URL}/contact`}>contact us</a> for
                assistance.
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid>
          {isChunkLoadError ? (
            <Button
              onClick={() => window.location.reload(true)}
              variant="outlined"
            >
              Reload
            </Button>
          ) : (
            <Button
              component={Link}
              to={redirectUrl}
              variant="outlined"
              reloadDocument
            >
              Back to App
            </Button>
          )}
        </Grid>
      </Grid>
    </Dialog>
  );
}

DefaultError.propTypes = {
  authData: PropTypes.object,
};

export default DefaultError;
